import type { Theme } from '@xstyled/styled-components'
import { defaultTheme } from '@xstyled/styled-components'
import { core } from './core'

const theme: Theme = {
  ...defaultTheme,
  ...core
}

export default theme
